import { UnikoServiceTypes } from "src/app/services/payments-api.service";
import { availableServices } from "./available-services";
import * as environment from '../../../../core/appSettings';
import { EnvironmentInjector } from "@angular/core";

export const technicalReportService = (injector: EnvironmentInjector) => ({
    logo: 'assets/svgs/rics-logo-black.svg',
    title: 'technicalReport.title',
    img: '../../../../assets/img/property-service-techreport.png',
    reportSampleDocumentName: 'Technical-Report-Template',
    reportSampleImageUrl: '',
    descPart1: `technicalReport.descriptionPart1`,
    descPart2: `technicalReport.descriptionPart2`,
    descPart3: `technicalReport.descriptionPart3`,
    section1Title: 'whyChooseService',
    deliveryDays: 5,
    serviceFee: 200,
    whyChooseService: [
      {
        icon: 'icon-investment',
        title: 'technicalReport.whyChoose.title1',
        description: 'technicalReport.whyChoose.description1'
      },
      {
        icon: 'icon-list-todo-alt',
        title: 'technicalReport.whyChoose.title2',
        description: 'technicalReport.whyChoose.description2'
      },
      {
        icon: 'icon-thumbs-up',
        title: 'technicalReport.whyChoose.title3',
        description: 'technicalReport.whyChoose.description3'
      }
    ],
    section2Title: 'nextSteps',
    nextSteps: [
      'technicalReport.nextSteps1',
      'technicalReport.nextSteps2',
      'technicalReport.nextSteps3'
    ],
    section3Title: 'lookAtTheseServices.title',
    section3Description: 'lookAtTheseServices.description',
    services: availableServices.filter((service) => service.type !== UnikoServiceTypes.technicalReport),
    requestServiceButtonLabel: 'technicalReport.requestTechnicalReport',
  });